import {
  WISHLIST_EXPORT,
  WISHLIST_EXPORT_FULFILLED,
  WISHLIST_EXPORT_REJECTED,
} from './actionTypes';
import {
  WishlistExportAction,
  WishlistExportFulfilledAction,
  WishlistExportRejectedAction,
} from './types';

const wishlistExport = (
  wishlistId: string,
  fileName: string,
  fileType?: string,
): WishlistExportAction => ({
  type: WISHLIST_EXPORT,
  payload: {
    wishlistId,
    fileName,
    fileType,
  },
});

const wishlistExportFulfilled = (): WishlistExportFulfilledAction => ({
  type: WISHLIST_EXPORT_FULFILLED,
});

const wishlistExportRejected = (
  error: ErrorType,
): WishlistExportRejectedAction => ({
  type: WISHLIST_EXPORT_REJECTED,
  payload: {
    error,
  },
});

export {
  wishlistExport,
  wishlistExportFulfilled,
  wishlistExportRejected,
};
